import { render } from "./boxy.vue?vue&type=template&id=07484578"
import script from "./boxy.vue?vue&type=script&lang=js"
export * from "./boxy.vue?vue&type=script&lang=js"

import "./boxy.vue?vue&type=style&index=0&id=07484578&lang=scss"

import exportComponent from "/srv/sites/eservice.talronbatt.co.il/api/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__